import { render, staticRenderFns } from "./RegisterSection.vue?vue&type=template&id=f13fdf3e&scoped=true"
import script from "./RegisterSection.vue?vue&type=script&lang=js"
export * from "./RegisterSection.vue?vue&type=script&lang=js"
import style0 from "./RegisterSection.vue?vue&type=style&index=0&id=f13fdf3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13fdf3e",
  null
  
)

export default component.exports